import { Button } from '@/shadcn-ui/button';
import { cn } from '@/shadcn-ui/utils';
import { colorsAlpha } from '@/theme/colors';
import LinkWithInventoryFilters from '../link-with-inventory-filters';

interface HeaderViewCarsButtonProps {
  dark?: boolean;
  className?: string;
}

export default function HeaderViewCarsButton({
  dark = false,
  className,
}: HeaderViewCarsButtonProps) {
  return (
    <LinkWithInventoryFilters to="/inventory">
      <Button
        className={cn(
          'h-[36px] w-[92px] rounded-[8px] border-[1px] border-solid p-[8px] text-[12px] font-[700] ring-0 hover:border-[2px] focus:ring-0 active:p-[8px] sm:w-[115px] sm:text-[14px]',
          className,
          {
            'text-flexcar-neutral100': dark,
            'text-flexcar-blue30': !dark,
            'backdrop-blur-[18px]': dark,
            'border-flexcar-blue70': dark,
            'border-flexcar-blue30': !dark,
            'bg-[linear-gradient(281deg,#69FEE1_-38.95%,#490AFF_94.52%)]': dark,
            'bg-flexcar-neutral100': !dark,
            'hover:bg-[linear-gradient(281deg,#69FEE1_-38.95%,#490AFF_94.52%)]': dark,
            'hover:bg-flexcar-neutral100': !dark,
            'active:bg-flexcar-neutral100': !dark,
          }
        )}
        style={{
          boxShadow: dark
            ? `0px 8px 24px 0px ${colorsAlpha.blue30Alpha5}, 0px 8px 24px 0px ${colorsAlpha.blue30Alpha8}, 0px 0px 1.5px 0px ${colorsAlpha.blue30Alpha25}`
            : `none`,
        }}
      >
        View cars
      </Button>
    </LinkWithInventoryFilters>
  );
}
